import React, { useState, useRef, useEffect } from "react";
import TripsStructure from "./ExploreComponents/TripsStructure";
import ExploreExpComingSoon from "./ExploreComponents/ExploreExpStructure";
import ExploreStaysComingSoon from "./ExploreComponents/ExploreStayStructure";
import PageHeaderBar from "@/components/common/PageHeaderBar";
import { Footprints, BedSingleIcon, Signpost } from "lucide-react";

const filters = [
  {
    id: "trips",
    label: "Trips",
    icon: <Signpost className="w-4 h-4" />,
  },
  {
    id: "experiences",
    label: "Experiences",
    icon: <Footprints className="w-4 h-4" />,
  },
  {
    id: "stays",
    label: "Stays",
    icon: <BedSingleIcon className="w-4 h-4" />,
  },
];

const Explore: React.FC = () => {
  const [activeTab, setActiveTab] = useState("trips");

  return (
    <section className="flex flex-col">
      <ExploreHeaderBar activeTab={activeTab} setActiveTab={setActiveTab} />
      <ExploreContent activeTab={activeTab} />
    </section>
  );
};

export default Explore;

const ExploreHeaderBar: React.FC<{
  activeTab: string;
  setActiveTab: (tab: string) => void;
}> = ({ activeTab, setActiveTab }) => {
  const [indicatorStyle, setIndicatorStyle] = useState({
    left: "0px",
    width: "0px",
    opacity: 0,
  });
  const tabsRef = useRef<{ [key: string]: HTMLButtonElement | null }>({});
  const tabsContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateIndicator = () => {
      const activeTabElement = tabsRef.current[activeTab];
      const tabsContainer = tabsContainerRef.current;

      if (activeTabElement && tabsContainer) {
        const tabRect = activeTabElement.getBoundingClientRect();
        const containerRect = tabsContainer.getBoundingClientRect();

        setIndicatorStyle({
          left: `${tabRect.left - containerRect.left}px`,
          width: `${tabRect.width}px`,
          opacity: 1,
        });
      }
    };

    // Initial update with a slight delay to ensure proper positioning
    const timer = setTimeout(() => {
      updateIndicator();
    }, 0);

    // Handle window resize
    window.addEventListener("resize", updateIndicator);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", updateIndicator);
    };
  }, [activeTab]);

  return (
    <div className="flex flex-col">
      <PageHeaderBar title="Explore" />
      <div className="flex flex-row w-full justify-start items-center min-h-16">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => setActiveTab(filter.id)}
            className={`mr-2 flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-full transition ease-in-out duration-300 ${
              activeTab === filter.id
                ? "bg-indigo-800 text-white"
                : "bg-indigo-50 text-indigo-600 hover:bg-indigo-200 hover:text-indigo-800 hover:shadow-sm"
            }`}
          >
            {filter.icon}
            <span>{filter.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const ExploreContent: React.FC<{ activeTab: string }> = ({ activeTab }) => {
  switch (activeTab) {
    case "trips":
      return <TripsStructure />;
    case "experiences":
      return (
        <div>
          <ExploreExpComingSoon />
        </div>
      );
    case "stays":
      return (
        <div>
          <ExploreStaysComingSoon />
        </div>
      );
    default:
      return null;
  }
};
